import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ChartControls from '../components/ChartControls';
import WaitingRoomChart from '../components/WaitingRoomChart';
import withAsyncLifecycle from '../../core/hoc/async-lifecycle';
import { selectHttpInfo } from '../../core/selectors/http';
import { getWaitingRoomChart } from '../actions/waiting-rooms';
import { selectWaitingRoomChart } from '../selectors/waiting-rooms';
import { GET_WAITING_ROOM_CHART_REQUEST_NAME } from '../api/config';
import {
    DEFAULT_END_DATE, DEFAULT_START_DATE, GROUPED_BY_MINUTE,
} from '../constants/charts';

const WaitingRoomChartContainer = ({ id, maxOutflow }) => {
    const dispatch = useDispatch();
    const data = useSelector((state) => selectWaitingRoomChart(state, id));

    const [startDate, setStartDate] = useState(DEFAULT_START_DATE);
    const [endDate, setEndDate] = useState(DEFAULT_END_DATE);
    const groupedBy = GROUPED_BY_MINUTE;

    useEffect(() => {
        if (startDate && endDate) {
            dispatch(getWaitingRoomChart(id, startDate, endDate, groupedBy));
        }
    }, [startDate, endDate, groupedBy]);

    const handleStartDateChange = (value) => {
        const selectedDate = new Date(value).getTime();
        setStartDate(selectedDate);
    };

    const handleEndDateChange = (value) => {
        const selectedDate = new Date(value).getTime();
        setEndDate(selectedDate);
    };

    const { isFetching, isError } = useSelector((state) => selectHttpInfo(state, GET_WAITING_ROOM_CHART_REQUEST_NAME));
    const WaitingRoomChartWithLifecycle = withAsyncLifecycle(WaitingRoomChart, {
        isFetching,
        isError,
    });

    return (
        <div>
            <ChartControls
                startDate={startDate}
                endDate={endDate}
                handleStartDateChange={handleStartDateChange}
                handleEndDateChange={handleEndDateChange}
            />
            <WaitingRoomChartWithLifecycle
                data={data}
                startDate={startDate}
                endDate={endDate}
                groupedBy={groupedBy}
                maxOutflow={maxOutflow}
            />
        </div>
    );
};

export default WaitingRoomChartContainer;
